export default __webpack_public_path__ + "static/media/ohshit.8a4c091f.gif";